// @flow
import { combineReducers } from 'redux';
import { ActionType } from 'typesafe-actions';
import * as actions from '../../actions/account';
import licenceReducer, { ILicenceState, initLicenceState } from './licence';
import sessionReducer, { initSessionState, ISessionState } from './session';
import userReducer, { initUserState, IUserState } from './user';

export type Actions = ActionType<typeof actions>;

interface IPersist {
  rehydrated: boolean;
  version: number;
}

export interface IState {
  session: ISessionState;
  user: IUserState;
  licence: ILicenceState;
  _persist?: IPersist;
}

export const initialState: IState = {
  licence: initLicenceState,
  session: initSessionState,
  user: initUserState,
};

// $FlowFixMe
const accountReducer = combineReducers({
  licence: licenceReducer,
  session: sessionReducer,
  user: userReducer,
});

export default accountReducer;
